<template lang="pug">

  section.decade(:class="orientation", :id="decadeid")
    .col-content
      .decade-title(:style="{color: colorTitle}") {{title}}'s
      Car(:carmodel="carmodel" :carpic="carpic" :carcolor="colorCar")
      .decade-content(v-html="stcontent", :style="{color: colorText}")
    .col-video

</template>

<script>
  import Car from '@/components/timeline/Car'

  export default  {
    name: 'decade',
    props: {
      title: String,
      stcontent: String,
      carmodel: String,
      musicurl: String,
      orientation: String,
      carpic: String,
      colorBackground: {
        type: String,
        default: '#e6e4e4'
      },
      colorTitle: {
        type: String,
        default: 'white'
      },
      colorText: {
        type: String,
        default: 'black'
      },
      colorCar: {
        type: String,
        default: 'black'
      }
    },
    components: {
      Car
    },
    computed: {
      decadeid(){
        return `decade-${this.title}`
      },
    },
    data() {
      return {

      }
    }
}
</script>

<style scoped lang="scss">
  .decade {
    display: grid;
    grid-template-columns: 40% 60%;
    &.right{
      grid-template-columns: 60% 40%;
    }
    grid-gap: 3rem;
    align-items: flex-start;
    padding: 3rem 5rem;
    transition: all .3s;
    @media screen and (max-width: 900px){
      grid-template-columns: 1fr;
      padding: 3px 1px;
    }
    .decade-title{
      left: -5rem;
      @media screen and (max-width: 900px){
        left: 0;
      }
    }
  }

  .decade-content{
    font-family: 'Open Sans', sans-serif;
    font-size: 1.2rem;
    line-height: 2.4rem;
    position: relative;
    z-index: 2;
  }

  .col-content,
  .col-video{
    position: relative;
  }

  .col-content{
    padding-top: 6.5rem;
    .right &{
      order: 2;
    }
    &:before{
      content: '';
      position: absolute;
      top: 5rem;
      left: 0;
      width: 70px;
      border-top: 8px solid black;
      z-index: 2;
      @media screen and (max-width: 900px){
        top: 3.2rem;
      }
    }
    @media screen and (max-width: 900px){
      padding-top: 4rem;
    }
  }

  .decade-title{
    font-size: 10rem;
    line-height: 10rem;
    color: white;
    position: absolute;
    z-index: 1;
    top: 0;
    @media screen and (max-width: 900px){
      font-size: 3rem;
      line-height: 3rem;
    }
  }


</style>
